import FifthSection from "../components/HomePage/FifthSection";
import { FirstSection } from "../components/HomePage/FirstSection";
import { FourthSection } from "../components/HomePage/FourthSection";
import { HeroSection } from "../components/HomePage/HeroSection";
import SecondSection from "../components/HomePage/SecondSection";
import ThirdSection from "../components/HomePage/ThirdSection";

export const Home = () => {
    return (
        <>
        <HeroSection />
        <FirstSection />
        <SecondSection />
        <ThirdSection />
        <FourthSection />
        <FifthSection />
        </>
    );
}